export interface ISesion {
  password: string;
  username_or_email?: string;
  username: string;
}

export enum RequestStatusEnum {
  success = 'success',
  error = 'error',
}

export interface IApiResponseD {
  data: any;
  status: string;
  message: string;
  code: number;
}

export interface IApiResponse<T> {
  data: T;
  status: string;
  message: string;
  code: number;
}

export interface IDataSelect {
  data: any[];
  count: number;
  current_page: undefined | number;
  next_page: undefined | string;
  num_pages: undefined | number;
}

export interface ArchivoResponse {
  code: number;
  status: string;
  message: string;
  data: IDataFile;
}

export interface IDataFile {
  id_archivos: string;
  nombre: string;
  fecha_creacion: string;
  fecha_modificacion: string;
  archivo: string;
  carpeta_padre: number;
  user: number;
  codigo: string; // no unique
}

// Generated by https://quicktype.io

export interface ImagesByArrPagingRes {
  last_id: number;
  count: number;
  next: null;
  previous: null;
  numero_paginas: number;
  data: ImagesByArrData[];
}

export interface ImagesByArrData {
  id_imagenes?: number;
  codigo: string;
  nombre: string;
  url: string;
  json_imagenes: string;
  ids_imagenes: string;
  fecha_creacion: string;
  fecha_modificacion: string;
  prospecto: null;
  preventa: null;
  cliente: null;
  orden_trabajo: number;
}

export enum CarpetaPadreIdEnum {
  MAIN = 1,
}
